import { render, staticRenderFns } from "./academic_ibc_refereesystem.vue?vue&type=template&id=e3ef6608&scoped=true&"
import script from "./academic_ibc_refereesystem.vue?vue&type=script&lang=js&"
export * from "./academic_ibc_refereesystem.vue?vue&type=script&lang=js&"
import style0 from "./academic_ibc_refereesystem.vue?vue&type=style&index=0&id=e3ef6608&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ef6608",
  null
  
)

export default component.exports